import type { ElementRef } from '@angular/core';
import { Component, forwardRef, input, model, viewChild } from '@angular/core';
import type { FormCheckboxControl } from '@angular/forms/signals';
import { ONYX_FOCUSABLE } from '../../../directives/onyx-auto-focus.directive';
import { OnyxBaseFormControlComponent } from '../../../internal/components/onyx-base-form-control/onyx-base-form-control.component';
import { OnyxErrorComponent } from '../../error/onyx-error/onyx-error.component';
import { OnyxInputLabelComponent } from '../../labels/onyx-input-label/onyx-input-label.component';

@Component({
  selector: 'onyx-toggle',
  imports: [OnyxInputLabelComponent, OnyxErrorComponent],
  templateUrl: './onyx-toggle.component.html',
  styleUrls: ['./onyx-toggle.component.scss'],
  host: {
    '(click)': `changeValue($event)`,
    '(keydown.space)': `changeValue($event)`,
  },
  providers: [
    {
      provide: ONYX_FOCUSABLE,
      useExisting: forwardRef(() => OnyxToggleComponent),
    },
  ],
})
export class OnyxToggleComponent
  extends OnyxBaseFormControlComponent
  implements FormCheckboxControl
{
  public readonly checked = model(false);
  public readonly label = input<string>('');
  public readonly size = input<28 | 32 | 40>(40);
  public readonly showRequired = input(false);
  public readonly showErrors = input(true);
  public readonly inactive = input(false);

  private readonly toggleElementRef =
    viewChild.required<ElementRef<HTMLButtonElement>>('toggleElement');

  public focus(): void {
    if (this.disabled() || this.inactive()) return;

    this.toggleElementRef().nativeElement.focus();
  }

  protected changeValue(event: Event): void {
    if (this.disabled() || this.inactive()) return;
    event.preventDefault();

    this.checked.update((value) => !value);
    this.touch.emit();
  }
}
